export enum TaskCompletedType {
	Incompleted = 0,
	Completed = 1
}